import angular from 'angular';

import component from './products-manage.component';

const ProductsManage = angular
    .module('control-room.components.menus.components.products-manage', [])
    .component('crProductsManage', component);

export default ProductsManage;
